import { ReactNode } from "react";
import ThreeDotsLoader from "@/components/common/three-dots-loader";

/** Consistent page header for the supply-config list pages. */
export function SupplyPageHeader({
  title,
  actions,
}: {
  title: string;
  actions?: ReactNode;
}) {
  return (
    <div className="flex items-center justify-between">
      <h1 className="text-xl font-semibold">{title}</h1>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

/**
 * Consistent bordered list card: an optional controls bar (filters + search),
 * shared loading / error / empty states, the table as children, and an
 * optional footer (pagination).
 */
export function SupplyListCard({
  controls,
  isLoading,
  error,
  isEmpty,
  emptyText = "Nothing here yet.",
  footer,
  children,
}: {
  controls?: ReactNode;
  isLoading?: boolean;
  error?: unknown;
  isEmpty?: boolean;
  emptyText?: string;
  footer?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden">
      {controls && (
        <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 bg-gray-50 border-b border-gray-100">
          {controls}
        </div>
      )}
      {isLoading ? (
        <div className="flex justify-center py-12">
          <ThreeDotsLoader />
        </div>
      ) : error ? (
        <div className="px-4 py-10 text-center text-sm text-red-600">
          Failed to load
        </div>
      ) : isEmpty ? (
        <div className="px-4 py-10 text-center text-sm text-gray-400">
          {emptyText}
        </div>
      ) : (
        <>
          {children}
          {footer}
        </>
      )}
    </div>
  );
}
